import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL, PRODUCT_LINE_STATUS, PRODUCT_LINE_STATUS_REASON } from '@core/constants';
import { IProductLineClinicalReviewNoteDTO } from '@core/model/note.model';
import { ApplicationStateService } from '@core/service/application-state.service';
import { Observable } from 'rxjs';
import { IProductLineDTO, IProductLineDataForCascadingNote } from '../model';

@Injectable({
  providedIn: 'root',
})
export class NotesService {
  constructor(
    private http: HttpClient,
    private applicationStateService: ApplicationStateService,
    @Inject(API_URL) private apiUrl: string
  ) {}

  /**
   * Get clinical review notes
   */
  getClinicalReviewNotes(
    referenceId: string
  ): Observable<IProductLineClinicalReviewNoteDTO[]> {
    return this.http.get<IProductLineClinicalReviewNoteDTO[]>(
      `${this.getBaseUrl()}/reference-id/${referenceId}?types=Clinical Review`
    );
  }

  private getBaseUrl(): string {
    const tenantId = this.applicationStateService.tenantId;
    return `${this.apiUrl}/api/${tenantId}/notes`;
  }

  getOtherPLsForCascading(productLine: IProductLineDTO, productLines: IProductLineDTO[]): IProductLineDataForCascadingNote[] {
    return productLine.status.applicationKey !== PRODUCT_LINE_STATUS.Incomplete
      ? productLines.reduce((res, pl) => {
        if (pl.status.applicationKey !== PRODUCT_LINE_STATUS.Incomplete && pl.productLineId !== productLine.productLineId) {
          res.push({
            applicationKey: pl.status.applicationKey,
            referenceId: pl.productLineId,
            productNumber: `${pl.sequenceNumber} - ${pl.hcpcsAndModifier}`,
            hcpcsPlusModifier: pl.hcpcsAndModifier,
            isIntentToDeny: pl.statusReason.applicationKey === PRODUCT_LINE_STATUS_REASON.IntentToDeny,
            denialRationale: pl.productLineClinicalRationale?.denialRationale,
          });
        }
        return res;
      }, [] as IProductLineDataForCascadingNote[]) : [];
  }
}
